"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCooperativeZoneCharges = void 0;
const const_1 = require("../../../const");
const routes_1 = require("../../routes");
const getCooperativeZoneCharges = (client) => async (params, query, responseType = const_1.ResponseType.JSON) => {
    const headers = {
        Accept: responseType === const_1.ResponseType.CSV ? const_1.SUPPORTED_MEDIA_TYPE.CSV : const_1.SUPPORTED_MEDIA_TYPE.APPLICATION_JSON,
    };
    const response = await client.get(routes_1.ENDPOINTS.GET_COOPERATIVE_ZONE_CHARGES.applyParams(params), { params: query, headers });
    return response.data;
};
exports.getCooperativeZoneCharges = getCooperativeZoneCharges;
